import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=8d465700&scoped=true"
import script from "./layout-footer.vue?vue&type=script&lang=js"
export * from "./layout-footer.vue?vue&type=script&lang=js"
import style0 from "./layout-footer.vue?vue&type=style&index=0&id=8d465700&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d465700",
  null
  
)

export default component.exports